/* MUSE & MAKER - mm-piece-sheet.js, 28 Sep 2026. THE SIZE SHEET, phones only.
   Loaded by sections/mm-piece-index.liquid. Runs only when the viewport is
   under 38em at load; desktop and tablet keep the hover chips and are not
   touched by this file. Clara's ruling: the tile is the door, the sheet is
   the room. Tap a card with sizes and a sheet slides up on the grid page:
   the size renders off the products (one scale, made to be compared), the
   size name and from-price on each, and ONE button into the configurator
   named for the chosen size. Clara, 28 Sep: no large render above the sizes -
   the to-scale tiles ARE the picture. Clara, 5 Oct: BEDS show no dimensions
   line - the size name (Single ... Super king) is enough; every other piece
   keeps its L x D x H. A bed is a card whose data-col is the beds collection.
   A card with one size skips the sheet and goes straight through, as before.
   Everything it needs is already on the card: each .mmpi__sz chip carries
   href, data-img, data-price and data-w/d/h. No second copy of the data. */
(function(){
  if(!window.matchMedia('(max-width:37.99em)').matches)return;
  var root=document.getElementById('mmpi');
  if(!root)return;
  var cards=root.querySelectorAll('.mmpi__card.has-sizes');
  if(!cards.length)return;

  var scrim=document.createElement('div');scrim.className='mmpi-scrim';
  var sheet=document.createElement('section');
  sheet.className='mmpi-sheet';sheet.setAttribute('role','dialog');sheet.setAttribute('aria-modal','true');sheet.setAttribute('aria-hidden','true');
  sheet.innerHTML=
    '<div class="mmpi-sheet__grab"></div>'+
    '<div class="mmpi-sheet__head"><h3 class="mmpi-sheet__title"></h3><button type="button" class="mmpi-sheet__close" aria-label="Close">&times;</button></div>'+
    '<p class="mmpi-sheet__sub">Choose a size, then configure it in any fabric.</p>'+
    '<div class="mmpi-sheet__body"><div class="mmpi-sheet__sizes"></div></div>'+
    '<div class="mmpi-sheet__foot"><a class="mmpi-sheet__cta" href="#"></a></div>';
  document.body.appendChild(scrim);document.body.appendChild(sheet);

  var title=sheet.querySelector('.mmpi-sheet__title'),sizes=sheet.querySelector('.mmpi-sheet__sizes'),cta=sheet.querySelector('.mmpi-sheet__cta'),closeBtn=sheet.querySelector('.mmpi-sheet__close');
  var cur=null,chips=[],lastFocus=null;

  var BEDS='maker-collection-bed';
  function dims(a){
    var w=+a.getAttribute('data-w')||0,d=+a.getAttribute('data-d')||0,h=+a.getAttribute('data-h')||0;
    var parts=[];if(w)parts.push('L '+w);if(d)parts.push('D '+d);if(h)parts.push('H '+h);
    return parts.length?parts.join(' × ')+' cm':'';
  }
  function pick(i){
    var a=chips[i];if(!a)return;
    var tiles=sizes.children;
    for(var j=0;j<tiles.length;j++){tiles[j].classList.toggle('is-on',j===i);tiles[j].setAttribute('aria-pressed',j===i?'true':'false');}
    cta.href=a.getAttribute('href');
    cta.textContent='Configure the '+a.textContent.trim()+' →';
  }

  function open(card){
    cur=card;chips=[].slice.call(card.querySelectorAll('.mmpi__sz'));
    var isBed=(card.getAttribute('data-col')||'')===BEDS;
    var nm=card.querySelector('.mmpi__nm');title.textContent=nm?nm.textContent.trim():'';
    sizes.innerHTML='';
    chips.forEach(function(a,i){
      var b=document.createElement('button');b.type='button';b.className='mmpi-sheet__sz';
      var u=a.getAttribute('data-img'),p=a.getAttribute('data-price')||'';
      b.innerHTML='<span class="mmpi-sheet__thumb">'+(u?'<img src="'+u+'" alt="" loading="lazy">':'')+'</span>'+
        '<span class="mmpi-sheet__l1">'+a.textContent.trim()+'</span>'+
        (!isBed&&dims(a)?'<span class="mmpi-sheet__l3">'+dims(a)+'</span>':'')+
        (p?'<span class="mmpi-sheet__l2">From '+p+'</span>':'');
      b.addEventListener('click',function(){pick(i);});
      sizes.appendChild(b);
    });
    pick(0);
    /* Fit the thumbs: every size at the family's smallest scale, each centred on its own render
       (assets/mm-piece-fit.js). Falls back to the stylesheet's blanket scale if it is missing. */
    if(window.mmFit){
      var items=[];chips.forEach(function(a,i){var im=sizes.children[i]&&sizes.children[i].querySelector('.mmpi-sheet__thumb img');var u=a.getAttribute('data-img');if(im&&u)items.push({img:im,url:u});});
      window.mmFit.fitGroup(items,{w:0.86,h:0.86});
    }
    lastFocus=document.activeElement;
    scrim.classList.add('is-on');sheet.classList.add('is-on');sheet.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('mmpi-sheet-open');
    sheet.setAttribute('tabindex','-1');sheet.style.outline='none';sheet.focus();
  }
  function close(){
    scrim.classList.remove('is-on');sheet.classList.remove('is-on');sheet.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('mmpi-sheet-open');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }

  cards.forEach(function(card){
    var doors=card.querySelectorAll('.mmpi__hit, .mmpi__nm a');
    doors.forEach(function(el){el.addEventListener('click',function(e){e.preventDefault();open(card);});});
  });
  scrim.addEventListener('click',close);
  closeBtn.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet.classList.contains('is-on'))close();});
  var y0=null;
  sheet.addEventListener('touchstart',function(e){y0=e.touches[0].clientY;},{passive:true});
  sheet.addEventListener('touchend',function(e){if(y0!==null&&e.changedTouches[0].clientY-y0>70)close();y0=null;},{passive:true});
})();